import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
    color: theme.custom.warning,
  },
  icon: {
    marginRight: 5,
  },
}));
